import { formatNumber } from "helpers/utils";

export interface Column {
    id:
        | "title"
        | "author"
        | "balancePrev"
        | "quantity"
        | "additionalRights"
        | "collectiveManagement"
        | "audiovisualAdaption"
        | "other"
        | "advanceAmount"
        | "grossDuty"
        | "balance"
        | "amount";
    label: string;
    minWidth?: number;
    align?: "right" | "left" | "center";
    class?: string;
    format?: (str: string) => string;
}

export const columns: readonly Column[] = [
    {
        id: "title",
        label: "Title",
        minWidth: 200,
        align: "left",
    },
    {
        id: "author",
        label: "Author",
        align: "left",
        minWidth: 100,
    },
    {
        id: "balancePrev",
        label: "Balance N-1",
        minWidth: 50,
        align: "center",
        //   class: "box yellow",
        format: (value) =>
            formatNumber(Math.round(+value) / 100, {
                isCurrency: true,
                always2Digit: false,
            }),
    },
    {
        id: "advanceAmount",
        label: "AdvanceAmount",
        minWidth: 50,
        align: "center",
        format: (value) =>
            formatNumber(-Math.round(+value) / 100, {
                isCurrency: true,
                always2Digit: false,
            }),
    },
    {
        id: "quantity",
        label: "Rights/Sales",
        minWidth: 50,
        align: "center",
        //   class: "box blue",
        format: (value) =>
            formatNumber(Math.round(+value) / 100, {
                isCurrency: true,
                always2Digit: false,
            }),
    },
    {
        id: "additionalRights",
        label: "Additional rights",
        minWidth: 50,
        align: "center",
        format: (value) =>
            formatNumber(Math.round(+value) / 100, {
                isCurrency: true,
                always2Digit: false,
            }),
    },
    {
        id: "audiovisualAdaption",
        label: "Audiovisual adaption",
        minWidth: 50,
        align: "center",
        format: (value) =>
            formatNumber(Math.round(+value) / 100, {
                isCurrency: true,
                always2Digit: false,
            }),
    },
    {
        id: "collectiveManagement",
        label: "Collective management",
        minWidth: 50,
        align: "center",
        format: (value) =>
            formatNumber(Math.round(+value) / 100, {
                isCurrency: true,
                always2Digit: false,
            }),
    },
    {
        id: "other",
        label: "Other",
        minWidth: 50,
        align: "center",
        format: (value) =>
            formatNumber(Math.round(+value) / 100, {
                isCurrency: true,
                always2Digit: false,
            }),
    },
    {
        id: "grossDuty",
        label: "Gross duty payable",
        minWidth: 50,
        //   class: "box yellow",
        align: "center",
        format: (value) =>
            formatNumber(Math.round(+value) / 100, {
                isCurrency: true,
                always2Digit: false,
            }),
    },
    {
        id: "balance",
        label: "Balance",
        minWidth: 50,
        align: "center",
        format: (value) =>
            formatNumber(Math.round(+value) / 100, {
                isCurrency: true,
                always2Digit: false,
            }),
    },
];
